import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pathfinder-website/pathfinder-website/app/sdk/components/ClassDetailTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pathfinder-website/pathfinder-website/app/sdk/components/SdkSidebar.tsx");
